import { SfgGeruestAuthProcessInterface } from './sfg-geruest-state.model';

export class SfgGeruestStateSetAuthProcess {
  static readonly type = '[SfgGeruestState] Set AuthProcess';

  constructor(public authProcessData: SfgGeruestAuthProcessInterface) {}
}

export class SfgGeruestStateSetHasProjects {
  static readonly type = '[SfgGeruestState] Set hasProjects';

  constructor(public hasProjects: boolean) {}
}
